import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameMobilePreviewDisplay extends cDisplay {

  private ccList: number[]
  private tmpSprite: Phaser.GameObjects.Sprite

  init(){
    super.init()

    console.log('MOBILE PREVIWE');

    (this.scene as cScene).ev.addListener('action',(command,options)=>{
      console.log(command)
      switch (options.command ){
        case 'start_upload':
          break;
      }
    })


    var d = document.createElement('div');
    d.classList.add('fixed','debug-upload')
    d.innerHTML = '<label>Upload<input id="fileupload" type="file" name="fileupload" /></label>'
    document.querySelector('body').appendChild(d);

    d.querySelector('input').addEventListener('change',()=>{
      this.handleUpload( d.querySelector('input').files[0] )      
    })
  }

  async handleUpload(r) {


    if (this.tmpSprite){
      this.remove(this.tmpSprite,true);
      this.scene.textures.remove('TMP_DATA');
      console.log('REMOD')
    }


    let base64 = await this.toBase64(r)
    let s = this.scene.textures.addBase64('TMP_DATA',base64);

    this.scene.textures.on('onload',(r)=>{

      console.log('loaded...',r);
      this.tmpSprite = new Phaser.GameObjects.Sprite(this.scene,0,0,'TMP_DATA')

      console.log(this.tmpSprite.width)
      this.add(this.tmpSprite)
      
      this.tmpSprite.x = (1920/2)
      this.tmpSprite.y = (1080/2)

    });




  }

  toBase64(file){
    return  new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
      });
    }  



  buildScene(){
    super.buildScene();
  }

  mounted(){
  }




}
